export default __webpack_public_path__ + "static/media/BG-LightBlue-0002.faac0e93.png";